import { StyleSheet } from 'react-native';
import colors, { appTheme } from '@/config/colors';
import { isPatientApp } from '@/config/constants';

export const styles = StyleSheet.create({
  container: {
    alignContent: 'center',
    backgroundColor: isPatientApp ? '#FFFFFF' : colors.newUI.therapist.bgBlue10,
    flex: 1,
    padding: 20,
  },
  formWrapper: {
    paddingTop: 20,
    paddingBottom: 10,
  },
  formField: {
    paddingBottom: 5,
    alignItems: 'center',
  },
  inputText: {
    borderColor: '#ACAFAC',
    borderRadius: 3,
    borderWidth: 1,
    color: '#555555',
    fontWeight: '400',
    fontSize: 20,
    height: 55,
    paddingLeft: 15,
    textAlign: 'left',
    width: '75%',
    marginHorizontal: 'auto',
  },
  checkboxWrapper: {
    flexDirection: 'column',
    paddingTop: 10,
    paddingRight: 10,
  },
  checkbox: {
    alignContent: 'center',
    marginBottom: 10,
    paddingRight: 12,
    width: '95%',
  },
  checkBoxText: {
    fontSize: 16,
    textAlign: 'left',
  },
  openLink: {
    fontWeight: '700',
    fontSize: 18,
    color: '#5B79EC',
  },
  registration: {
    color: '#FFFFFF',
    fontSize: 22,
    fontWeight: '700',
    padding: 15,
    textAlign: 'center',
  },
  registrationButton: {
    backgroundColor: appTheme.primary,
  },
  subtitle: {
    fontWeight: '500',
    fontSize: 18,
    textAlign: 'center',
    paddingBottom: 10,
    paddingHorizontal: 50,
    marginTop: 6,
  },
  subtitle2: {
    fontWeight: '500',
    fontSize: 18,
  },
  title: {
    fontWeight: '500',
    fontSize: 25,
    textAlign: 'center',
  },
  mandatoryTextCheck: {
    color: '#505351',
    fontSize: 16,
    fontWeight: '700',
  },
  mandatoryErrorCheck: {
    color: '#FF3A20',
    fontSize: 16,
    fontWeight: '700',
  },
  errorMessage: {
    alignSelf: 'center',
    color: '#FF3A20',
    fontWeight: '700',
    width: '75%',
    marginHorizontal: 'auto',
    paddingVertical: 2.5,
  },
  boldMessage: {
    alignSelf: 'flex-start',
    fontWeight: '700',
  },
  registrationErrorMessage: {
    textAlign: 'center',
    color: '#FF3A20',
    fontWeight: '700',
  },
  subtitle2Container: {
    paddingBottom: 10,
    paddingHorizontal: 50,
  },
  font20: {
    fontSize: 20,
  },
  inputContainerStyle: {
    borderBottomWidth: 0,
    justifyContent: 'center',
    paddingHorizontal: 0,
    marginHorizontal: 0,
    height: '100%',
  },
  therapistInputWrapper: {
    width: '75%',
    alignSelf: 'center',
  },
});
